namespace Areas.MeetingMinutes.List {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("MeetingMinutes", ["Active", "Completed", "Deleted"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function onGridSelectionChanged(e: any) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            enableButton("EditButton");
        } else {
            disableButton("EditButton");
        }
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/MeetingMinutes/Profile/View/{placeholder}'>Edit</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.meetingMinutesProfileId; },
            linkInfo);
    }

    export function view() {
        gotoSelected("MeetingMinutesListGrid", "/MeetingMinutes/Profile/View/");
    }

    export function edit() {
        gotoSelected("MeetingMinutesListGrid", "/MeetingMinutes/Profile/Edit/");
    }

    export function showCreate() {
        const createMeetingMinutesProfileDialog = new Areas.Dialogs.CreateMeetingMinutesProfileDialog(() => { });
    }

}